<template>
  <div class="duration-input font-weight-bold" :class="{focus:focus}">
    <input class="duration-input--field"
      maxlength="2"
      @keypress="isNumber($event)"
      @focus="onFocus"
      @blur="onBlur"
      v-model="val_a.value"
      @input="onInput"
      />
    <span :class="checkLimit(val_a) ? 'limit-warning' : ''"> {{ getLabel(0) }} : </span>
    <input class="duration-input--field"
      maxlength="2"
      @keypress="isNumber($event)"
      @focus="onFocus"
      @blur="onBlur"
      v-model="val_b.value"
      @input="onInput"
      />
    <span :class="checkLimit(val_b) ? 'limit-warning' : ''"> {{ getLabel(1) }} : </span>
    <input class="duration-input--field"
      maxlength="2"
      @keypress="isNumber($event)"
      @focus="onFocus"
      @blur="onBlur"
      v-model="val_c.value"
      @input="onInput"
      />
    <span :class="checkLimit(val_c) ? 'limit-warning' : ''"> {{ getLabel(2) }}</span>
  </div>
</template>

<script>
import {ref, reactive} from '@vue/composition-api';

export default {

  name: 'DurationInput',

  props: {
    value: {
      type: String,
      default: "00:01:00"
    },
    format: {
      type: String,
      default: 'DHM'
    },
    limits: {
      type: String,
      default: '99:24:60'
    }
  },

  setup(props, {emit}){

    const val_a = reactive({
      value: getVal(props.value, 0),
      limit: getVal(props.limits, 0)
    });

    const val_b = reactive({
      value: getVal(props.value, 1),
      limit: getVal(props.limits, 1)
    });

    const val_c = reactive({
      value: getVal(props.value, 2),
      limit: getVal(props.limits, 2)
    });

    const focus = ref(false);

    function getVal(str, num)
    {
      return str.split(':')[num];
    }

    function getLabel(num)
    {
      return props.format.split('')[num];
    }

    function onInput()
    {
      let formated_duration = limitAndAddZero(val_a.value, val_a.limit) + ":" + limitAndAddZero(val_b.value, val_b.limit) + ":" + limitAndAddZero(val_c.value, val_c.limit);
      emit('input', formated_duration);
    }

    // https://stackoverflow.com/questions/39782176/filter-input-text-only-accept-number-and-dot-vue-js
    function isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
        evt.preventDefault();
      } else {
        return true;
      }
    }

    function onFocus(evt){
      focus.value = true;

      evt.target.select();
    }

    function onBlur()
    {
      focus.value = false;

      let abc = ['a', 'b', 'c'];
      for(const letter of abc){
        let tval = eval('val_' + letter);
        tval.value = limitAndAddZero(tval.value, tval.limit);
      }
    }

    function checkLimit(val)
    {
      return (parseInt(val.value, 10) > parseInt(val.limit, 10));
    }

    function limitAndAddZero(value, limit)
    {
      //set value to limit
      if(parseInt(value, 10) > parseInt(limit, 10))
      {
        value = limit;
      }
      //add zeros
      value = ("00" + value).slice(-2);

      return value;
    }

    return {isNumber, onFocus, onBlur, getLabel, checkLimit, onInput, val_a, val_b, val_c, focus};
  }
}
</script>

<style lang="scss" scoped>
  .duration-input {
    border: 1px solid map-get($grey, 'lighten-1');
    border-radius: 5px;
    display: flex;
    justify-content: center;
    padding: $spacer - 2px $spacer - 2px $spacer - 2px $spacer;
    margin-right: 1rem;
    width: 100%;

    &.focus {
      border: 1px solid map-get($green, 'darken-1');
    }

    .duration-input--field {
      position: relative;
      z-index: 2;
      text-align: center;
      font-size: 16px;
      line-height: 20px;
      width: 25px;

      &:focus {
        outline: none;
      }
    }

    span {
      position: relative;
      font-size: 16px;
      line-height: 20px;
      margin: 0 3px;
      white-space: nowrap;

      &::before {
        position: absolute;
        left: -22px;
        bottom: -3px;
        z-index: 1;
        content: '_ _';
        font-size: 14px;
        font-weight: 400;
        width: 25px;
        height: 16px;
      }

      &.limit-warning::before{
        color: map-get($red, 'darken-1');
      }
    }
  }
</style>
